module.exports = __webpack_public_path__ + "static/media/icon-coin-regulatory-bottom.804d7572.png";